import classNames from "classnames";
import React, { ReactNode } from "react";
import { Link } from "react-router-dom";

type NavigationCardProps = {
  title: string;
  description: string;
  meta?: string;
  to: string;
  icon: ReactNode;
  className?: string;
};

export const NavigationCard: React.FC<NavigationCardProps> = ({
  title,
  description,
  meta,
  to,
  icon,
  className,
}) => {
  return (
    <Link
      to={to}
      className={classNames(
        "group flex min-h-[174px] flex-col rounded-lg border border-[#E4E9F2] bg-white p-5 font-Manrope shadow-[0_8px_24px_rgba(20,34,61,0.04)] transition hover:border-[#CBB8FF] hover:shadow-[0_12px_30px_rgba(105,56,239,0.12)] focus:outline-none focus:ring-2 focus:ring-[#6938EF]/30",
        className,
      )}>
      <div
        className={
          "mb-5 flex h-10 w-10 items-center justify-center rounded-lg bg-[#F3EDFF] text-[#8B5CF6] transition group-hover:bg-[#EDE4FF]"
        }>
        {icon}
      </div>

      <div className={"text-base font-semibold text-[#253747]"}>{title}</div>
      <div className={"mt-2 max-w-[260px] text-sm leading-5 text-[#8A99AA]"}>
        {description}
      </div>

      {meta ? (
        <div className={"mt-auto pt-4 text-sm font-semibold text-[#6938EF]"}>
          {meta}
        </div>
      ) : null}
    </Link>
  );
};
